import(/* webpackMode: "eager", webpackExports: ["ChatBot"] */ "/app/apps/home/src/app/[locale]/(main)/store/components/chatbot/chatbot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/home/src/app/[locale]/(main)/store/components/items/contact-form-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/home/src/app/[locale]/(main)/store/components/scroll-to-top-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreItemSheetProvider"] */ "/app/apps/home/src/app/[locale]/(order)/components/store-item/store-item-sheet-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrderListSheetProvider"] */ "/app/apps/home/src/app/[locale]/order-list/order-list-sheet-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/home/src/components/address-cookie-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentWrapper"] */ "/app/apps/home/src/components/navigation/content-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationProvider"] */ "/app/apps/home/src/components/navigation/navigation-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationWrapper"] */ "/app/apps/home/src/components/navigation/navigation-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreCityIdSheetManager"] */ "/app/apps/home/src/components/store-city-sheet-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreCitySheetProvider"] */ "/app/apps/home/src/contexts/store-city-sheet-context.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/home/src/lib/is-mobile/is-ssr-mobile-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/home/src/lib/is-mobile/use-is-mobile.ts");
;
import(/* webpackMode: "eager" */ "/app/apps/home/src/lib/is-mobile/use-window-size.ts");
;
import(/* webpackMode: "eager", webpackExports: ["DetectWebinappProvider"] */ "/app/apps/home/src/lib/is-webinapp/is-detect-webinapp-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider"] */ "/app/apps/home/src/lib/react-query/query-client-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/apps/home/src/providers/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/apps/home/src/providers/theme-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/home/src/store/cart/cart-store-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/home/src/styles/navigation-overrides.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/lib/fonts/index.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/lib/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./svn-gilroy-regular.ttf\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./svn-gilroy-medium.ttf\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"./svn-gilroy-semibold.ttf\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"./svn-gilroy-bold.ttf\",\"weight\":\"700\",\"style\":\"normal\"}],\"variable\":\"--font-gilroy\",\"fallback\":[\"sans-serif\",\"system-ui\",\"arial\"]}],\"variableName\":\"gilroy\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/app/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/globals.css");
